import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, BadgeCheckIcon } from 'lucide-react';
import { TESTIMONIALS } from '../constants/content';
import { StarRating } from './StarRating';
export function SocialProof() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-249">
      <div className="mx-auto max-w-5xl px-4" data-id="element-250">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mb-10 text-center" data-id="element-251">
          <h2 className="font-display text-3xl font-700 leading-tight text-ink sm:text-4xl" data-id="element-252">
            Lo Que Dicen Nuestros Clientes
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-base text-gray-600" data-id="element-253">
            No quiero que te quedes solo con mi palabra. Mirá lo que cuentan
            algunos de los que ya usan Pollería Rentable 2026:
          </p>
        </motion.div>

        {/* Masonry via CSS columns */}
        <div className="columns-1 gap-6 sm:columns-2 [&>*]:mb-6" data-id="element-254">
          {TESTIMONIALS.map((t, i) => <motion.figure key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.45,
          delay: i % 2 * 0.08
        }} className="break-inside-avoid rounded-2xl bg-cream p-6 shadow-sm ring-1 ring-black/5" data-id="element-255">
              <QuoteIcon className="mb-3 h-8 w-8 text-gold" aria-hidden="true" data-id="element-256" />
              <StarRating className="mb-3" size={16} data-id="element-257" />
              <figcaption className="mb-2 font-display text-lg font-600 text-crimson" data-id="element-258">
                «{t.title}»
              </figcaption>
              <blockquote className="mb-5 text-base leading-relaxed text-gray-800" data-id="element-259">
                «{t.quote}»
              </blockquote>
              <div className="flex items-center gap-3" data-id="element-260">
                <img src={t.img} alt={`Foto de ${t.name}`} className="h-12 w-12 rounded-full object-cover ring-2 ring-gold/40" data-id="element-261" />
                <div data-id="element-262">
                  <p className="font-700 text-ink" data-id="element-263">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-264">{t.location}</p>
                </div>
                <BadgeCheckIcon className="ml-auto h-5 w-5 text-green-600" aria-label="Compra verificada" data-id="element-265" />
              </div>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}